import { Injectable } from '@angular/core';
import {KroneHttpService} from '@api/http/krone/krone-http.service';
import {IShopItem} from '@api/models/shop/shop-item';

@Injectable({
  providedIn: 'root'
})
export class ShopService {

  public shopItems: IShopItem[] = [];
  constructor(private kroneHttp: KroneHttpService) {}

  public async init(): Promise<void> {
    await this.getShopItems();
  }

  private async getShopItems() {
    const response = await this.kroneHttp.getShopItems();
    if (response) {
      this.shopItems = response.data
    }
  }
}
